import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Buildings, ArrowLeft, EnvelopeSimple, Check } from '@phosphor-icons/react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      // Always show success to not reveal if email exists
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-4">
        <div className="w-full max-w-md bg-white border border-zinc-200 p-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-100 mb-4">
              <Check size={32} className="text-emerald-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-zinc-900 mb-2">
              Correo Enviado
            </h1>
            <p className="text-zinc-600 mb-6">
              Si el correo <strong>{email}</strong> está registrado en el sistema, 
              recibirás instrucciones para restablecer tu contraseña.
            </p>
            <p className="text-sm text-zinc-500 mb-6">
              Revisa tu bandeja de entrada y la carpeta de spam.
            </p>
            <Link
              to="/login"
              className="btn-primary inline-flex items-center gap-2"
              data-testid="back-to-login-btn"
            >
              <ArrowLeft size={18} />
              Volver al Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-4">
      <div className="w-full max-w-md bg-white border border-zinc-200 p-8">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Buildings size={28} weight="bold" className="text-zinc-900" />
            <h1 className="font-heading text-2xl font-bold tracking-tight text-zinc-900">
              Recuperar Contraseña
            </h1>
          </div>
          <p className="text-zinc-500 text-sm">
            Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="alert-error text-sm" data-testid="forgot-error">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="email" className="form-label">
              Correo electrónico
            </label>
            <div className="relative">
              <EnvelopeSimple size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input pl-10"
                placeholder="correo@empresa.cl"
                required
                data-testid="forgot-email-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="forgot-submit-btn"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Enviando...
              </>
            ) : (
              'Enviar Instrucciones'
            )}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="text-sm text-zinc-600 hover:text-zinc-900 inline-flex items-center gap-1"
            data-testid="back-to-login-link"
          >
            <ArrowLeft size={16} />
            Volver al Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
